import React from "react";
import NavLinks from "../components/NavLinks";
import { Link } from "react-router-dom";


export default class Header extends React.Component {
  render() {
    return (
      <header>
          <nav className="navbar navbar-default navbar-vetchat navbar-fixed-top">
            <div className="container">
            <div className="navbar-header">
              {/* Mobile Hamburger Button */}
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#mobile-menu"
                  aria-expanded="false"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
                <Link to="/" className="vetchat-brand">
                  <img src="/images/vetchat-logo.png" alt="vetchat-logo" className="vetchat-logo"/>
                </Link>
            </div>
            <div className="collapse navbar-collapse" id="mobile-menu">
              <ul className="nav navbar-nav navbar-right">
                <NavLinks />
              </ul>
            </div>
            </div>
          </nav>     
      </header>
    );
  }
}
